document.addEventListener('DOMContentLoaded', function () {
  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      const initialize = () => {
        if (this.swiper || typeof window.Swiper !== 'function') return
        this.swiper = this.initSwiper()
      }

      const swiperReady = window.monvaneSwiperReady || Promise.resolve(window.Swiper)
      swiperReady.then(initialize)
    }

    get getCurrentSlidesPerView() {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
          prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
        } : false,
        scrollbar: this['scrollbar'] ? {
          el: ".swiper-scrollbar",
          hide: true,
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 4;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })

      return swiper
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGCountdown extends HTMLElement {
    constructor() {
      super();
      this.countdown();
    }

    countdown() {
      const cutOffTime = this.querySelector('.yg-countdown-timer').dataset.countdownTimer;
      const cunOffElemet = this.querySelector('.yg-countdown-timer');

      function updateTimer() {
        const time = (+new Date(cutOffTime) - Date.now()) / 1000;

        const days = Math.floor(time / (60 * 60 * 24));
        const hours = Math.floor((time % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((time % (60 * 60)) / 60);
        const seconds = Math.floor(time % 60);
        const formattedDays = days.toString().padStart(2, '0');
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        cunOffElemet.querySelector('.yg-countdown-days').innerHTML = formattedDays;
        cunOffElemet.querySelector('.yg-countdown-hours').innerHTML = formattedHours;
        cunOffElemet.querySelector('.yg-countdown-minutes').innerHTML = formattedMinutes;
        cunOffElemet.querySelector('.yg-countdown-seconds').innerHTML = formattedSeconds;
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    }
  }

  if (!window.customElements.get('yg-countdown')) {
    window.customElements.define('yg-countdown', YGCountdown);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const header = this.querySelector('.yg-accordion-header');
      const content = this.querySelector('.yg-accordion-content');
      const hasParentAccordion = this.parentNode.closest('.yg-accordion');
      const isRetractableTab = this.classList.contains('yg-retractable-tab');
      const isTabItemAccordionFirst = this.classList.contains('yg-tab-item-accordion-first');
      const isTabItemAccordion = this.classList.contains('yg-tab-item-accordion');
      const downloadSection = this.closest('.yg-download-section');
      let allTabItemAccordions = null;
      if (downloadSection) {
        allTabItemAccordions = downloadSection.querySelectorAll('.yg-tab-item-accordion');
      }
      const contentHeight = content.scrollHeight;
      this.style.setProperty('--content-height', `${contentHeight}px`);

      if (isRetractableTab) {
        header.classList.add('active');
        content.classList.add('active');

        if (hasParentAccordion) {

          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          if (originalContentHeight) {
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if (header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
      }

      if (isTabItemAccordionFirst) {
        header.classList.add('active');
        content.classList.add('active');

        if (hasParentAccordion) {

          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          if (originalContentHeight) {
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if (header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
      }

      header.addEventListener('click', () => {
        header.classList.toggle('active');
        content.classList.toggle('active');
        if (hasParentAccordion) {

          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          if (originalContentHeight) {
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if (header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
        if (downloadSection && isTabItemAccordion && header.classList.contains('active')) {
          allTabItemAccordions.forEach(accordion => {
            if (accordion === this) return;

            const accordionHeader = accordion.querySelector('.yg-accordion-header');
            const accordionContent = accordion.querySelector('.yg-accordion-content');

            if (!accordionHeader || !accordionContent) return;

            if (accordionHeader.classList.contains('active') || accordionContent.classList.contains('active')) {
              accordionHeader.classList.remove('active');
              accordionContent.classList.remove('active');

              const retractableTab = accordion.parentNode.closest('.yg-accordion');
              if (retractableTab) {
                const retractableOriginalHeight = parseFloat(retractableTab.style.getPropertyValue('--content-height')) || 0;
                const accordionContentHeight = parseFloat(accordion.style.getPropertyValue('--content-height')) || accordionContent.scrollHeight || 0;
                const nextHeight = Math.max(retractableOriginalHeight - accordionContentHeight, 0);
                retractableTab.style.setProperty('--content-height', `${nextHeight}px`);
              }
            }
          });
        }
      });
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    window.customElements.define('yg-accordion', YGAccordion);
  }
  class YGDownload extends HTMLElement {
    constructor() {
      super();
      this.init()
    }

    fileDownload(url, name) {
      this.classList.add('active');
      fetch(url)
        .then(response => {
          const contentType = response.headers.get("content-type");
          let fileExtension = "";
          if (contentType.includes("application")) {
            fileExtension = contentType.split("/")[1];
          } else if (contentType.includes("image")) {
            fileExtension = contentType.split("/")[1];
          }
          return response.arrayBuffer().then(buffer => ({ buffer, extension: fileExtension }));
        })
        .then(({ buffer, extension }) => {
          const blob = new Blob([buffer], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${extension}`); // 替换为期望的下载文件名
          document.body.appendChild(link);
          link.click();
          this.classList.remove('active');
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }).catch(error => {
          console.error('Error fetching the file:', error);
        });
    }
    init() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.getAttribute('data-link') != '' && this.getAttribute('data-file-name') != '#') {
          this.fileDownload(this.getAttribute('data-link'), this.getAttribute('data-file-name'))
        }

      });
    }
  }

  if (!window.customElements.get('yg-download')) {
    customElements.define('yg-download', YGDownload);
  }

  class YGInfoAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => {
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-info-accordion")) {
    window.customElements.define("yg-info-accordion", YGInfoAccordion);
  }

  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-product-item');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGColectionProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.collectionSwiperReady) return;
      this.collectionSwiperReady = true;

      const interactionTarget = this.closest('details') || this;
      const initialize = () => {
        window.monvaneLoadSwiper?.();
        const swiperReady = window.monvaneSwiperReady || Promise.resolve(window.Swiper);

        swiperReady.then(() => {
          if (this.swiper || typeof window.Swiper !== 'function') return;
          this.swiper = this.initSwiper();
          requestAnimationFrame(() => this.swiper?.update());
        });
      };

      interactionTarget.addEventListener('pointerenter', initialize, { once: true, passive: true });
      interactionTarget.addEventListener('focusin', initialize, { once: true });
      interactionTarget.addEventListener('toggle', () => {
        if (interactionTarget.open) initialize();
      }, { once: true });

      if (window.matchMedia('(max-width: 749px)').matches) {
        requestAnimationFrame(initialize);

        if ('ResizeObserver' in window) {
          this.collectionSwiperResizeObserver = new ResizeObserver((entries) => {
            if (!entries.some((entry) => entry.contentRect.width > 0)) return;
            initialize();
            requestAnimationFrame(() => {
              this.swiper?.update();
              this.updateMobileNavigation?.();
            });
          });
          this.collectionSwiperResizeObserver.observe(this);
        }
      } else if (interactionTarget === this && 'IntersectionObserver' in window) {
        this.collectionSwiperObserver = new IntersectionObserver((entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          initialize();
        }, { rootMargin: '300px 0px' });
        this.collectionSwiperObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.collectionSwiperObserver?.disconnect();
      this.collectionSwiperResizeObserver?.disconnect();
    }

    setupMobileNavigation(swiper) {
      const slideCount = this.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
      if (!window.matchMedia('(max-width: 749px)').matches || slideCount <= 2) return;

      const previousButton = document.createElement('button');
      const nextButton = document.createElement('button');

      previousButton.type = 'button';
      nextButton.type = 'button';
      previousButton.className = 'yg-mobile-product-arrow yg-mobile-product-arrow--previous';
      nextButton.className = 'yg-mobile-product-arrow yg-mobile-product-arrow--next';
      previousButton.setAttribute('aria-label', 'Previous products');
      nextButton.setAttribute('aria-label', 'More products');
      previousButton.innerHTML = '&#8249;';
      nextButton.innerHTML = '&#8250;';

      this.append(previousButton, nextButton);

      const updateButtons = () => {
        const activeIndex = Number.isFinite(swiper.activeIndex) ? swiper.activeIndex : 0;
        previousButton.hidden = activeIndex <= 0;
        nextButton.hidden = activeIndex >= slideCount - 2;
      };

      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        swiper.slidePrev();
      });
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        swiper.slideNext();
      });
      this.updateMobileNavigation = updateButtons;
      swiper.on('slideChange', updateButtons);
      swiper.on('reachBeginning', updateButtons);
      swiper.on('reachEnd', updateButtons);
      requestAnimationFrame(() => {
        swiper.update();
        updateButtons();
      });
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: 10,
      });

      this.setupMobileNavigation(swiper);
      return swiper;
    }
  }

  if (!window.customElements.get('yg-colection-products')) {
    window.customElements.define('yg-colection-products', YGColectionProducts);
  }
})


!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();



